const CareersPageActionTypes = {
  ENABLE_OFFICE: 'ENABLE_OFFICE',
  HANDLE_MOBILE_FILTER_MENU: 'HANDLE_MOBILE_FILTER_MENU',
};

export default CareersPageActionTypes;
